import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './inputForeignZipCode.css';
import useTranslator from '../../../translation/hooks/useTranslator';
import { IMaskInput } from 'react-imask';

export const InputForeignZipCode = props => {
  const {
    setValue,
    field,
    countryField,
    index,
  } = props;
  
  const { Translation } = useTranslator();

  // TODO: Remove this hardcoded when backend retrieves the correct props
  const maskOptions = [
    {
      pattern: null,
      label: Translation('FIELDS.WITHOUT_MASK'),
      img: '/assets/countries/none.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_NONE_ALT'),
      countryId: null,
    },
    {
      pattern: 'a0000aaa',
      label: 'A999AAA',
      img: '/assets/countries/ar.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_ARG_ALT'),
      countryId: 32,
    },
    {
      pattern: '00000-000',
      label: '99999-999',
      img: '/assets/countries/br.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_BRA_ALT'),
      countryId: 76,
    },
    {
      pattern: '0000000',
      label: '9999999',
      img: '/assets/countries/cl.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_CHL_ALT'),
      countryId: 152,
    },
    {
      pattern: '000000',
      label: '999999',
      img: '/assets/countries/co.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_COL_ALT'),
      countryId: 170,
    },
    {
      pattern: '00000',
      label: '99999',
      img: '/assets/countries/mx.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_MEX_ALT'),
      countryId: 484,
    },
    {
      pattern: '00000',
      label: '99999',
      img: '/assets/countries/pe.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_PER_ALT'),
      countryId: 604,
    },
    {
      pattern: '00000',
      label: '99999',
      img: '/assets/countries/us.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_USA_ALT'),
      countryId: 840,
    },
    {
      pattern: '00000',
      label: '99999',
      img: '/assets/countries/uy.png',
      alt: Translation('FIELDS.MASK_DROPDOWN.MASK_IMG_URY_ALT'),
      countryId: 858,
    },
  ]
  
  const DEFAULT_ZIPCODE_VALUES = {value: '', mask: maskOptions[0], country: maskOptions[0].countryId};
  const [zipcode, setZipCode] = useState({ ...DEFAULT_ZIPCODE_VALUES});
  const [isMaskDropdownOpen, setIsMaskDropdownOpen] = useState(false);

  const handleInputChange = (value, mask) => {
    const isValid = zipcode?.mask?.pattern ? !value.includes('_') || mask.masked._value === '' : true;
    zipcode.value = value;
    setZipCode({...zipcode});
    setValue(mask.masked.value, index, field.ObjectKey, field.Required, isValid, Translation('FIELDS.MASK_ERROR'));
  }

  const setMaskForZipCode = (mask) => () => {
    zipcode.value = '';
    zipcode.mask = mask;
    zipcode.country = mask.countryId;
    setZipCode({...zipcode});
    setValue(zipcode.country, countryField.index, countryField.field.ObjectKey, countryField.field.Required, true);
  }

  const toggleMaskDropdown = () => {
    setIsMaskDropdownOpen(!isMaskDropdownOpen);
  }

  const MaskDropdown = () => (
    <div className="form-content__zipcode-selector__dropdown">
      <ul>
        {maskOptions.map((mask, index) => (
          <li onClick={setMaskForZipCode(mask)} key={index}>
            <img src={mask.img} alt={mask.alt} />
            {mask.label}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className='form-content__zipcode-wrapper'>
      {false && <div className='form-content__validation'>{Translation('FIELDS.INVALID_INPUT')}</div>}
        <div className='form-content__zipcode-row'>
          <div className='form-content__zipcode-selector --left' onClick={toggleMaskDropdown}>
            <img src={zipcode.mask.img} alt={zipcode.mask.alt} />
            {isMaskDropdownOpen && <MaskDropdown />} 
          </div>
          <IMaskInput
            className={`form-content__input ${false ? '--invalid' : ''}`}
            prepareChar={str => str.toUpperCase()}
            onAccept={handleInputChange}
            value={zipcode.value}
            name={field.FieldKey}
            mask={zipcode.mask?.pattern ?? /[\s\S]+/}
            placeholderChar='_'
            lazy={false}
          />
        </div>
    </div>
  );
}

InputForeignZipCode.propTypes = {
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  countryField: PropTypes.object,
  index: PropTypes.number.isRequired,
}